export enum PageTypes {
  EDIT_MY_REQUEST = 'editMyRequest',
  CREATE_MY_REQUEST = 'createMyRequest',
  MY_REQUESTS = 'myRequests',
  RESPOND_TASK = 'respondTask',
  APPROVALS = 'approvals',
  PROCUREMENT = 'procurement',
  EDIT_PROCUREMENT = 'editProcurement',
  CREATE_PROCUREMENT = 'createProcurement',
  DASHBOARD = 'dashboard',
  CONTACTS = 'contacts', // No EFFECT if REMOVED.
}
